import * as types from './types';

const initialState = {
  isTransparent: false,
  offlineMissingArr: [],
  isOpenMissModal: false,
};

const offlineProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SAVING_DATA_MISSING: {
      const data = action.payload;
      return {
        ...state,
        offlineMissingArr: data,
        isOpenMissModal: data && data.length > 0 ? true : false,
      };
    }
    case types.RESET_DATA:
      return initialState;
    default:
      return state;
  }
};
export default offlineProcessReducer;
